<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <h2 v-bind:id="myid">Essential Links</h2>
      <a @click="navgat">点击我</a>
    <ul>
      <li>
        <a
          href="https://vuejs.org"
          target="_blank"
        >
          Core Docs
        </a>
      </li>
      <li>
        <a
          href="https://forum.vuejs.org"
          target="_blank"
        >
          Forum
        </a>
      </li>
      <li>
        <a
          href="https://chat.vuejs.org"
          target="_blank"
        >
          Community Chat
        </a>
      </li>
      <li>
        <a
          href="https://twitter.com/vuejs"
          target="_blank"
        >
          Twitter
        </a>
      </li>
      <br>
      <li>
        <a
          href="http://vuejs-templates.github.io/webpack/"
          target="_blank"
        >
          Docs for This Template
        </a>
      </li>
    </ul>
    <h2>Ecosystem</h2>
    <ul>
      <li>
        <a
          href="http://router.vuejs.org/"
          target="_blank"
        >
          vue-router
        </a>
      </li>
      <li>
        <a
          href="http://vuex.vuejs.org/"
          target="_blank"
        >
          vuex
        </a>
      </li>
      <li>
        <a
          href="http://vue-loader.vuejs.org/"
          target="_blank"
        >
          vue-loader
        </a>
      </li>
      <li>
        <a
          href="https://github.com/vuejs/awesome-vue"
          target="_blank"
        >
          awesome-vue
        </a>
      </li>
    </ul>
      <div id="example">
          <p>Original message: "{{ msg }}"</p>
          <p>Computed reversed message: "{{ reversedMessage }}"</p>
      </div>
      <button @click="changemsgvalue">修改值</button>
      <ul>
          <li v-for="(value, key, index)  in items"> {{ index }}. {{ key }}: {{ value }}</li>
      </ul>
      <div id="example-1">
          <button v-on:click.once="dothat">测试</button>
          <p>The button above has been clicked {{ counter }} times.</p>
      </div>
      <div @click.right="doSomething">Do something</div>
    <input v-model="message" placeholder="edit me">
    <p>Message is: {{ message }}</p>
    <input type="checkbox" id="checkbox" v-model="checked">
    <label for="checkbox">{{ checked }}</label>
    <input type="radio" v-model="pick" v-bind:value="a">
    <p>pick:{{pick}}</p>
    <input v-model.trim="message">

    <send-message :news="goodnews" @click.native="dosomething">
    <h1 slot="header">这里可能是一个页面标题</h1>

    <p>主要内容的一个段落。</p>
    <p>另一个主要段落。</p>

    <p slot="footer">这里有一些联系信息</p>
    </send-message>
    <input v-model="itemname" placeholder="输入需要的项目" @keyup.enter="setitem"/>
    <button @click="testme">测试</button>
    <component v-bind:is="currentView">
        <!-- 组件在 vm.currentview 变化时改变！ -->
    </component>
    <button @click="show = !show">Toggle show</button>
    <transition
            :duration="{ enter: 5500, leave: 800 }"
            name="custom-classes-transition"
            enter-active-class="animated tada"
            leave-active-class="animated bounceOutRight"
            >
        <p v-if="show">hello</p>
    </transition>
  </div>
</template>

<script>
    import SendMessage from '@/components/SendMessage'
    var Home = {
        template: '<p>Welcome home!</p>'
    }
export default {
  name: 'HelloWorld',
   components:{
            'send-message':SendMessage
        },
  data () {
    return {
        show: true,
        currentView: Home,
        counter: 1,
        itemname: '',
        goodnews:[{username : '黄小米'}],
        a:'nihao',
        pick:'',
        checked: 1,
        counter: 0,
        message: 'Hello',
        myid: 'goodid',
      msg: 'Welcome to Your Vue.js App',
        items:[
            {name:'李帅',age:15},
            {name:'哥们',age:33}
        ]
    }
  },
    computed: {
        // 计算属性的 getter
        reversedMessage: function () {
            // `this` 指向 vm 实例
            return this.msg.split('').reverse().join('')
        }
    },
    methods: {
        navgat: function(){
            this.$router.push({name: 'Index',params: {id:1,name: 'zhangsan'},query: {id:1,name: 'zhangsan'}})
        },
        setitem: function(){
            if(this.itemname != '')
            this.goodnews.push({username : this.itemname})
            this.itemname = ''
        },
        testme: function (){
            this.goodnews.username = '我是小公主'
        },
        changemsgvalue: function (){
            this.msg = 'good boy'
        },
        dothat: function (){
            console.log("ok")
        },
        doSomething: function (){
            alert("ok")
        },
        dosomething: function (){
            alert("good")
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .bounce-enter-active {
        animation: bounce-in .5s;
    }
    .bounce-leave-active {
        animation: bounce-in .5s reverse;
    }
    @keyframes bounce-in {
        0% {
            transform: scale(0);
        }
        50% {
            transform: scale(1.5);
        }
        100% {
            transform: scale(1);
        }
    }
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue